import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocIpv4Entity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="ip" className="heading-1">Cyber/CVE</h3>
                    <div className="description"> In the cyber domain, Common Vulnerabilities and Exposures (CVE) numbers 
                        may also be extracted. A CVE number is a unique identifier assigned to a publicly disclosed cybersecurity 
                        vulnerability. These numbers commonly follow the pattern CVE-YYYY-NNNNNNN, where they always begin 
                        with "CVE-", YYYY is a year 1999 or newer, and NNNNNNN is a sequence number that can be 4-7 digits.
                        <div className="note">
                            <span className="fa fa-info-circle fa-xl">&nbsp;</span>
                            For more information on CVE, see: <a href="https://www.cve.org/About/Overview">Common Vulnerabilities and Exposure</a>
                        </div>
                        An extracted CYBER/CVE entity may be represented by the following attributes:
                        <br/>
                        All attributes are always present:
                    </div>
                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            {/* <th>Constraints </th> */}
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">sequence</td>
                            <td className="meaning">The CVE sequence number.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Mandatory</td> */}
                         
                        </tr>
                        <tr>
                            <td className="attribute">year</td>
                            <td className="meaning">The year of the vulnerability.</td>
                            <td className="type">Integer</td>
                            {/* <td className="constraints">Mandatory</td> */}
                            
                        </tr>
                        <tr>
                            <td className="attribute">url</td>
                            <td className="meaning">The url to the full list of details for this CVE number.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        
                        </tbody>
                    </table>

                    <h4 className="heading-2">Examples</h4>
                    Below is an example of text containing a CVE number.
                    <div className="example-content host">
                        INPUT:
                        <pre>"The vulnerability CVE-2021-44228, also known as Log4Shell, permits a Remote Code Execution (RCE), 
                            allowing the attackers to execute arbitrary code on the host."</pre>
                        <br/>
                        OUTPUT:
                        <pre>{JSON.stringify({
                                'entities': [
                                    {
                                        'label': 'CVE-2021-44228',
                                        'type': 'CYBER/CVE',
                                        'count': 1,
                                        'attributes': {
                                            'sequence': '44228',
                                            'year': 2021,
                                            'url': 'https://www.cve.org/CVERecord?id=CVE-2021-44228'
                                        },
                                        'mentions': [
                                            {
                                                'position': [
                                                    18,
                                                    32
                                                ],
                                                'extractedText': 'CVE-2021-44228',
                                                'extractionConfidence': 1.0
                                            }
                                        ]
                                    }
                                ]
                            }, null, 3)}
                        </pre>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocIpv4Entity;